import {Modal} from 'antd'
import {getId, getType} from 'apis/model/base'
import {LayoutContext} from 'components/layouts/Default/LayoutContext'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useCallback, useContext, useMemo, useState,} from 'react'
import {BiTrash} from 'react-icons/bi'
import {useLocation} from 'react-router-dom'
import {branch, compose} from 'recompose'
import {ContentNotFound} from 'views/AppLocals/ContentNotFound'
import {showDeleteConfirmDialog} from 'views/AppLocals/factory/createConfirmDialog'
import createContextMenu from 'views/AppLocals/factory/createContextMenu'
import {notifyOnError} from 'views/AppLocals/factory/createErrorEvent'
import {bindQueryParams,} from 'views/AppLocals/functions/routerHelper'
import usePaginationHelper, {createPagerKey,} from 'views/AppLocals/hooks/usePaginationHelper'
import {NullAsDefault} from 'views/Shared'
import {useRouteSearchParam} from "../../../../envs/_current/history";
import {useCatholicHouseholds} from "../../../AppLocals/CatholicHousehold/functions/useCatholicHouseholds";
import {renderCatholicHousehold} from "../functions/renderCatholicHousehold";
import {catholicHousehold_getCatholicHouseholds_Api} from "../../../../apis/catholicHousehold";
import {DetailViewForm} from "../../../AppLocals/CatholicHousehold/components/CatholicHouseholdForm";
import {CatholicHouseholdActionTypes} from "../../../AppLocals/CatholicHousehold/consts/CatholicHouseholdActionTypes";
import {RiSearchEyeLine} from "react-icons/ri";
import CatholicHouseholdContext, {CatholicHouseholdProvider} from "../../../AppLocals/CatholicHousehold/CatholicHouseholdContext";
import {PiCheckCircle} from "react-icons/pi";
import {CatholicHouseholdApproveForm} from "../components/CatholicHouseholdApproveForm";
import ListHeader from "../../../AppLocals/Templates/items/ListHeader";
import LoadingBlock from "../../../LoadingBlock";

const PendingCatholicHouseholds = ({
                                       owner_id,
                                       owner_type,
                                       filter_actions = {
                                           sortBy: 'sort-by',
                                           keyword: 'keyword',
                                       },
                                   }) => {
    const t = useTranslate()
    const location = useLocation()
    const {isSm} = useContext(LayoutContext)
    const [refreshKey, setRefreshKey] = useState()
    const [action, setAction] = useState({type: undefined, value: undefined,})
    const sortBy = useRouteSearchParam(filter_actions.sortBy)
    const status = -1;

    const onCancel = () => {
        setAction({})
    }

    const onRefresh = () => {
        setRefreshKey(Date.now())
    }
    const onSuccess = () => {
        setRefreshKey(Date.now())
        onCancel()
    }

    const onError = notifyOnError(t)

    const {onDelete, onChangeStatus} = useCatholicHouseholds({
        owner_type, owner_id,
        notifyListeners: {
            onDeleted: onSuccess,
            onStatusChanged: onSuccess,
        },
    })

    const handleAction = (action, params) => {
        const [id, prop] = [getId(params), getType(params)]
        switch (action) {
            case CatholicHouseholdActionTypes.CATHOLIC_HOUSEHOLD_VIEW:
                setAction({type: action, value: params})
                break
            case CatholicHouseholdActionTypes.CATHOLIC_HOUSEHOLD_APPROVE:
                setAction({type: action, value: params})
                break
            case CatholicHouseholdActionTypes.CATHOLIC_HOUSEHOLD_DELETE:
                if (id) {
                    showDeleteConfirmDialog({
                        translate: t,
                        title: 'delete household',
                        message: 'are you sure you want to delete this household',
                        onOk: () => {
                            onDelete({}, {id})
                        },
                    })
                }
                break
            default:
                break
        }
    }

    const renderContextMenu = useCallback(
        (item) =>
            createContextMenu(
                [
                    {
                        icon: <RiSearchEyeLine size={14} className="text-color-400"/>,
                        label: <span className="text-sm text-color-200">{t('quick view')}</span>,
                        key: CatholicHouseholdActionTypes.CATHOLIC_HOUSEHOLD_VIEW,
                    },
                    {
                        icon: <PiCheckCircle size={14} className="text-green-600"/>,
                        label: <span className="text-sm text-color-200">{t('approve')}</span>,
                        disable: item?.status === 1,
                        key: CatholicHouseholdActionTypes.CATHOLIC_HOUSEHOLD_APPROVE,
                    },
                    {
                        icon: <BiTrash size={14} className="text-primary-300"/>,
                        label: <span className="text-sm text-color-200">{t('delete')}</span>,
                        key: CatholicHouseholdActionTypes.CATHOLIC_HOUSEHOLD_DELETE,
                    },
                ].filter((e) => item),
                (key) => {
                    handleAction(key, item)
                }
            ),
        []
    )

    const modal = useMemo(() => {
        const {id} = action?.value ?? {}
        let title
        let Content = NullAsDefault
        let Wrapper = ({children}) => children({initialValues: {}})
        let params = {title: undefined}
        let modal_params = {}
        switch (action?.type) {
            case CatholicHouseholdActionTypes.CATHOLIC_HOUSEHOLD_VIEW:
                params = {
                    onCancel
                }
                modal_params = {
                    width: 820,
                    maskClosable: true,
                    className: 'custom-modal'
                }
                Content = ({...rest}) => (
                    <CatholicHouseholdProvider item={action.value}>
                        <CatholicHouseholdContext.Consumer>
                            {({item}) => {
                                return (
                                    <DetailViewForm
                                        {...rest}
                                        item={item}
                                    />
                                )
                            }}
                        </CatholicHouseholdContext.Consumer>
                    </CatholicHouseholdProvider>
                )
                break
            case CatholicHouseholdActionTypes.CATHOLIC_HOUSEHOLD_APPROVE:
                params = {
                    onCancel: () => {
                        setAction({})
                        setRefreshKey(Date.now())
                    },
                }
                modal_params = {
                    width: 740,
                    maskClosable: true,
                    className: 'appModal custom-modal'
                }
                Content = ({...rest}) => (
                    <CatholicHouseholdProvider item={action.value}>
                        <CatholicHouseholdContext.Consumer>
                            {({item}) => {
                                return (
                                    <CatholicHouseholdApproveForm
                                        {...rest}
                                        item={item}
                                    />
                                )
                            }}
                        </CatholicHouseholdContext.Consumer>
                    </CatholicHouseholdProvider>
                )
                break
            default:
                break
        }
        return (
            <Modal
                footer={null}
                title={title}
                onCancel={onCancel}
                open={action?.type}
                destroyOnHidden={true}
                // maskClosable={true}
                className="custom-modal"
                {...modal_params}>
                <Wrapper>
                    {({isLoading, initialValues}) => {
                        if (!!isLoading) {
                            return <LoadingBlock/>
                        }
                        return (
                            <Content
                                {...params}
                                {...{owner_id, owner_type}}
                                initialValues={initialValues}
                            />
                        )
                    }}
                </Wrapper>
            </Modal>
        )
    }, [action, owner_id, owner_type])

    const refresh_deps = useMemo(
        () => [
            owner_id,
            owner_type,
            refreshKey,
            `refreshToken=${_.get(location.state, 'refreshToken')}`,
        ],
        [owner_id, owner_type, refreshKey, location.state]
    )

    const [pager_widget] = usePaginationHelper({
        filter_params: {
            owner_id,
            owner_type
        },
        onInit: ({onSortChange = NullAsDefault, onFilterChange = NullAsDefault}) => {
            onFilterChange({
                status
            })
            onSortChange(sortBy)
        },
        withValues: (values) => ({
            ...values,
            status: -1
        }),
        pagerInfo: {
            RenderEntity: React.Fragment,
            renderItem: renderCatholicHousehold({
                renderContextMenu,
                handleAction: (type, value) => {
                    setAction({type, value});
                }
            }),
            apiInfo: catholicHousehold_getCatholicHouseholds_Api,
            query: bindQueryParams([{id: owner_id}, {type: owner_type}]),
        },
        SortByWidget: NullAsDefault,
        renderSortBy: NullAsDefault,
        isToggleDefault: false,
        query_params: filter_actions,
        renderFilter: NullAsDefault,
        // AdvancedFilter: CatholicHouseholdFilter,
        dependencies: [owner_id, owner_type, status],
        withKey: createPagerKey(refresh_deps),
    })
    return (
        <div className="flex flex-1 flex-col space-y-3">
            <ListHeader title={!isSm && 'pending catholic households'} className="flex-1"/>
            {pager_widget}
            {modal}
        </div>
    )
}


export default compose(
    branch(
        ({owner_id, owner_type}) => _.some([owner_id, owner_type], _.isEmpty),
        () => () => <ContentNotFound/>
    )
)(PendingCatholicHouseholds)
